import { clsx } from 'clsx';
import { type CSSProperties, type ReactNode, useEffect, useState } from 'react';
import { useGlobalUI } from '@contexts/GlobalUiContext';
import useUser from '@hooks/useUser';
import { isUserAdmin } from '@auth/authorization';
import { type Navigation } from '@models/Navigation';
import s from './app-menu.module.scss';
import { LinkItem } from './components/LinkItem/LinkItem';

interface AppMenuProps {
    menu: Navigation | null;
    className?: string;
    style?: CSSProperties;
}

export function AppMenu({ menu, className, style }: AppMenuProps): ReactNode {
    const user = useUser();
    const isAdmin = user ? isUserAdmin(user) : false;
    const { appClassName } = useGlobalUI();
    const classes = clsx(s.nav, className, appClassName);
    const [menuItems, setMenuItems] = useState<Navigation | null>(null);

    useEffect(() => {
        setMenuItems(menu);
    }, [menu]);
    return (
        <nav className={classes} style={style}>
            <ul className={s.list}>
                {menuItems?.items
                    .filter((item) => !item.admin || isAdmin)
                    .map((item) => (
                        <LinkItem
                            key={item.to}
                            item={item}
                            exact={item.exact}
                            sidebarCollapsed={appClassName === 'collapsed'}
                        />
                    ))}
            </ul>
        </nav>
    );
}
